import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  RouteScheduleResource,
  routeSchedulesSaveRouteSchedule,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditRouteSchedules = (
  options: UseMutationOptions<
    void,
    unknown,
    RouteScheduleResource,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: RouteScheduleResource) =>
      extractData(
        routeSchedulesSaveRouteSchedule({
          body: values,
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['RouteSchedules'],
      });
      options.onSuccess?.(...args);
    },
  });
};
